import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import "./Download_now.css"

const Download_now = () => {
    return (
        <section className='download '>
            <div className='download-section align-items-center'>
                <div className="container">
                    <Row>
                        <Col md={7}>
                            <div className='text_content'>
                                <h2 className='title'>
                                    We’re Available On App Too!
                                </h2>
                                <p className='subtitle'>
                                    Download Now & Enjoy Quick Recharges and Bill Payments in Minutes.
                                </p>
                            </div>
                        </Col>

                        <Col md={5}>
                           <div className='download_button'>
  <a
    href="https://play.google.com/store"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src='./assets/images/home/download_now/play_store.png'
      className='store_btn'
      alt="Google Play Store"
    />
  </a>

  <a
    href="https://www.apple.com/app-store/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src='./assets/images/home/download_now/App_store.png'
      className='store_btn'
      alt="Apple App Store"
    />
  </a>
</div>
                        </Col>
                    </Row>
                </div>
            </div>
        </section>
    )
}

export default Download_now;